import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';
const landings = (state) => state.landings.list;
const hostingTypes = (state) => state.landings.hostingTypes;
const capAsset = (state, props) => props.templateConfig?.assets?.cap;

export const getLandings = createSelector(
    landings,
    capAsset,
    (landings = [], cap) => {

        landings.forEach(item => {
            if(item.is_external) {
                item.preview_dynamic_url = item.external_url + '/preview.jpeg';
            } else if(item.preview_url !== null) {
                item.preview_dynamic_url = item.preview_url;
            } else {
                item.preview_dynamic_url = cap;
            }
        });

        return landings;
    }
);

export const getLandingsGallery = createSelector(
    landings,
    (landings = []) => {
        let vertical = [];
        let horizontal = [];
        let square = [];

        const push = (item, array, proportion) => {
            array.push({
                ...item,
                proportion,
                type: item.title,
                small: item.width < 120
            });
        };

        landings.forEach(item => {
            let ratio =  item.width / item.height;

            if (ratio > 1.3 && item.width > 250) {
                push(item, horizontal, 'horizontal');
            } else if (ratio < 0.7) {
                push(item, vertical, 'vertical');
            } else {
                push(item, square, 'square');
            }
        });

        square.sort((a, b) => {
            return a.width - b.width && a.height - b.height;
        });
        horizontal.sort((a, b) => {
            return b.width - a.width;
        });
        vertical.sort((a, b) => {
            return a.height - b.height;
        });

        return horizontal.concat(square, vertical);
    }
);

export const getHeaderNames = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().dataTable.headers;
        return [
            '№',
            staticNames.name,
            staticNames.hostingType,
            staticNames.action
        ];
    }
);

export const getHostingTypes = createSelector(
    hostingTypes,
    (hostingTypes = []) => {
        let list = [];
        let staticKeys = [];

        hostingTypes.map((item) => {
            staticKeys.push(item);
        });

        list.push({
            value: staticKeys.join(','),
            title: 'Static'
        });

        return list;
    }
);

export const getProportions = createSelector(
    () => {
        const proportions = UserStore.getTranslation().proportions;
        let list = [];

        for (let key in proportions) {
            list.push({
                value: key,
                title: proportions[key]
            });
        }

        return list;
    }
);
